import * as _ from 'lodash';

import IZoningCodeAttribute = ZoneIQCalibration.IZoningCodeAttribute;
import { AttributeModel } from '../../common-models/attribute.model';

export class ZoningCodeAttribute extends AttributeModel implements IZoningCodeAttribute {
    public Id?: number;
    public ZoningCodeId?: number;
    public TableFieldId?: number;
    public TableType?: number;

    constructor(data: any) {
        super(
            data,
            [
                'Id',
                'ZoningCodeId',
                'TableFieldId',
                'TableType',
                'AttributeType',
                'AttributeValue',
                'Description',
                'IsEnabled'
            ]
        );
    }

    static factory(data: IZoningCodeAttribute) {
        return new ZoningCodeAttribute(data);
    }
}
